var FlexibleEmailForm = {
  init: function init(el) {
    var $this = el;
    var $formSubmitButton = $this.find("#flexibleEmailFormComponent-submit");
    var $form = $this.find(".flexibleEmailFormComponent-form");
    var $recaptchaError = $this.find(".flexibleEmailFormComponent-recaptchaError");
    var $cookieError = $this.find(".flexibleEmailFormComponent-cookieError");
    var $idInput = $form.find("input[name=sitecoreItemId]");
    var $success = $this.find(".flexibleEmailFormComponent-success");
    FlexibleEmailForm.onModalShow($this);
    FlexibleEmailForm.onModalHide($this);
    if (sessionStorage.getItem("scrollToFormMessage") === "true") {
      sessionStorage.removeItem("scrollToFormMessage");
      if ($success.length) {
        setTimeout(function () {
          scrollToElement($success);
        }, 1000);
      } else {
        setTimeout(function () {
          scrollToElement($formSubmitButton);
        }, 1000);
      }
    }
    if ($recaptchaError.data("recaptcha-enabled") === "True") {
      grecaptcha.ready(function () {
        $formSubmitButton.click(function () {
          $formSubmitButton.prop("disabled", true);
          $cookieError.hide();
          var formCookie = cookieHelper.getCookie($idInput.val());
          if (formCookie) {
            $cookieError.show();
          } else {
            if ($form.valid()) {
              var recaptchaSite = $this.data("recaptcha-site");
              var consentValue = cookieHelper.getCookie("wscrCookieConsent");
              var consentSplit = consentValue.split("&");
              if (consentValue != "" && consentSplit[2] == "3=true") {
                grecaptcha.execute(recaptchaSite, {
                  action: "FormSubmit"
                }).then(function (token) {
                  $form.find(".flexibleEmailFormComponent-recaptchaToken").val(token);
                  $recaptchaError.hide();
                  FlexibleEmailForm.validateForm($this);
                }, function () {
                  $recaptchaError.show();
                  $formSubmitButton.prop("disabled", false);
                });
              }
              if (consentValue == "" || consentSplit[2] == "3=false") {
                $this.next('#flexibleEmailFormModal').modal();
              }
            } else {
              $formSubmitButton.prop("disabled", false);
            }
          }
        });
      });
    } else {
      $formSubmitButton.click(function () {
        $formSubmitButton.prop("disabled", true);
        $cookieError.hide();
        var formCookie = cookieHelper.getCookie($idInput.val());
        if (formCookie) {
          $cookieError.show();
        } else {
          if ($form.valid()) {
            FlexibleEmailForm.validateForm($this);
          } else {
            $formSubmitButton.prop("disabled", false);
          }
        }
      });
    }
  },
  validateCheckboxes: function validateCheckboxes(min, max, checked, minErrorText, rangeErrorText) {
    if (max > 0) {
      if (checked >= min && checked <= max) {
        return "true";
      }
      return rangeErrorText.replace("{min}", min).replace("{max}", max);
    } else {
      if (checked >= min) {
        return "true";
      }
      return minErrorText.replace("{min}", min);
    }
  },
  validateForm: function validateForm(el) {
    var $this = el;
    var $form = $this.find(".flexibleEmailFormComponent-form");
    var $formSubmitButton = $form.find("#flexibleEmailFormComponent-submit");
    var formOk = true;
    $this.find(".flexibleEmailFormComponent-htmlError").hide();
    $form.find(".flexibleEmailFormComponent-inputFile").each(function (i, obj) {
      if ($(this).data("required") === "True") {
        if ($(this).val() === "") {
          $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text($(this).data("no-file-error-text"));
          formOk = false;
        } else {
          $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text("");
        }
      }
    });
    $form.find(".flexibleEmailFormComponent-checkboxGroup").each(function (i, obj) {
      if ($(this).data("required") === "True") {
        var min = parseInt($(this).data("min")) || 0;
        var max = parseInt($(this).data("max")) || 0;
        var checkboxes = $(this).find('input[type="checkbox"]').length;
        var checked = $(this).find('input[type="checkbox"]').filter(':checked').length;
        if (Number.isInteger(min) && Number.isInteger(max) && (min > 0 || max > 0)) {
          if (checkboxes >= min && min > 0) {
            if (checkboxes >= max) {
              var result = FlexibleEmailForm.validateCheckboxes(min, max, checked, $(this).data("min-error-text"), $(this).data("range-error-text"));
              if (result !== "true") {
                $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text(result);
                formOk = false;
              } else {
                $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text("");
              }
            } else {
              var result2 = FlexibleEmailForm.validateCheckboxes(min, 0, checked, $(this).data("min-error-text"), $(this).data("range-error-text"));
              if (result2 !== "true") {
                $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text(result2);
                formOk = false;
              } else {
                $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text("");
              }
            }
          } else {
            if (checkboxes >= max && max > 0) {
              var result3 = FlexibleEmailForm.validateCheckboxes(0, max, checked, $(this).data("min-error-text"), $(this).data("range-error-text"));
              if (result3 !== "true") {
                $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text(result3);
                formOk = false;
              } else {
                $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text("");
              }
            } else {
              $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text("");
              return;
            }
          }
        } else {
          $("label[for='" + $(this).attr('id') + "']").children(".flexibleEmailFormComponent-validationError").text("");
          return;
        }
      }
    });
    $form.find(".flexibleEmailFormComponent-textInput").each(function (i, obj) {
      if ($(this).val() === "") {
        return;
      } else {
        var pattern = new RegExp("<[^>]*>");
        if (pattern.test($(this).val())) {
          $this.find(".flexibleEmailFormComponent-htmlError").show();
          formOk = false;
          return;
        }
      }
    });
    if (formOk) {
      sessionStorage.setItem("scrollToFormMessage", "true");
      $form.submit();
    } else {
      $formSubmitButton.prop("disabled", false);
    }
  },
  onModalShow: function onModalShow(el) {
    var $this = el;
    $this.next('#flexibleEmailFormModal').on('show.bs.modal', function (event) {
      var $modal = $(this);
      $modal.find(".flexibleEmailFormComponent-consent-accept").click(function () {
        FlexibleEmailForm.onConsentAccept(this, $this);
      });
      $modal.find(".flexibleEmailFormComponent-consent-remember").click(function () {
        var consentLevel = $(this).data("consent-enable");
        var cookieConsentValue = FlexibleEmailForm.buildCookieConsentAcceptedValue(consentLevel);
        cookieHelper.setCookie("wscrCookieConsent", cookieConsentValue, 365);
        FlexibleEmailForm.onConsentAccept(this, $this);
      });
      document.addEventListener("wscr.consent", function (event) {
        var remember = $modal.find(".flexibleEmailFormComponent-consent-remember");
        if (event.detail.consent[3]) {
          FlexibleEmailForm.onConsentAccept(remember, $this);
        }
      });
    });
  },
  onModalHide: function onModalHide(el) {
    var $this = el;
    $this.next('#flexibleEmailFormModal').on('hidden.bs.modal', function () {
      var $form = $this.find(".flexibleEmailFormComponent-form");
      var $formSubmitButton = $form.find("#flexibleEmailFormComponent-submit");
      $formSubmitButton.prop("disabled", false);
    });
  },
  onConsentAccept: function onConsentAccept($el, $this) {
    var $formSubmitButton = $this.find("#flexibleEmailFormComponent-submit");
    var modal = $el.closest('#flexibleEmailFormModal');
    var $recaptchaError = $this.find(".flexibleEmailFormComponent-recaptchaError");
    var recaptchaSite = $this.data("recaptcha-site");
    $(modal).modal('hide');
    grecaptcha.execute(recaptchaSite, {
      action: "FormSubmit"
    }).then(function (token) {
      $this.find(".flexibleEmailFormComponent-recaptchaToken").val(token);
      $recaptchaError.hide();
      FlexibleEmailForm.validateForm($this);
    }, function () {
      $recaptchaError.show();
      $formSubmitButton.prop("disabled", false);
    });
  },
  buildCookieConsentAcceptedValue: function buildCookieConsentAcceptedValue(consentLevel) {
    // Constructs the wscrCookieConsent value "1&2&3=true".
    return "1&2&".concat(consentLevel, "=true");
  }
};
$(document).ready(function () {
  $(".flexibleEmailFormComponent").each(function () {
    FlexibleEmailForm.init($(this));
  });
});